import React from 'react';
import './TeamSection.css';
import { FaWhatsapp } from 'react-icons/fa';
import Aman from './Images/Aman.jpg';
import AmanBrother from './Images/AmanBrother.jpg';
import Vivek from './Images/VivekSharma.jpg';
import Manish1 from "./Images/Manish1.jpg";
import procurementManager from "./Images/SalesManager.jpg";
import SalesManager from "./Images/Salesmanager1.jpg";

const teamMembers = [
    {
        name: 'Drx. A Sharma',
        role: 'Managing Director / CEO – GLC',
        about: "Leads GLC with strategic vision and direction. Focuses on global expansion, partnerships, and sustainable growth. Ensures all departments align with the company’s long-term mission and global standards.",
        img: Aman
    },
    {
        name: 'Sandesh Sharma',
        role: 'Business Development Manager – GLC',
        about: "Oversees client relationships and market expansion for GLC. Identifies new business opportunities, handles key accounts, and ensures steady growth. Coordinates with clients, suppliers, and internal teams to drive successful deals and long-term partnerships.",
        img: AmanBrother
    },
    {
        name: 'Mr. Vivek Sharma',
        role: 'Operation Head – GLC',
        about: "Manages GLC’s logistics, warehousing, and shipments. Ensures smooth and timely delivery across international borders. Coordinates with suppliers, transporters, and internal teams for seamless operations.",
        img: Vivek
    },
    {
        name: 'Mr. Vivek Chavda',
        role: 'Procurement Manager – GLC',
        about: "Leads sourcing and procurement of raw materials for GLC. Ensures quality, timely availability, and cost-effective purchasing from approved suppliers. Coordinates with vendors, QA teams, and logistics to maintain smooth supply chain operation",
        img: procurementManager
    },
    {
        name: 'Ms. Madhu Sharma',
        role: 'Sales/Marketing Head – GLC',
        about: "Drives GLC’s international sales and client outreach. Builds brand presence through strategic marketing and trade events. Identifies new market opportunities and maintains strong customer relationships worldwide.",
        img: SalesManager
    },
    {
        name: 'Mr. M Pandey',
        role: 'IT Head – GLC',
        about: "Manages all IT functions at GLC including website development in React, mobile app creation, and digital infrastructure. Leads automation, system integration, and technology-driven solutions to support global operations.",
        img: Manish1,
        isHoverable: true
    }
];

const TeamSection = () => (
    <section id="team" className="team-section">
        <div className="team-header">
            <h2>Meet Our Leadership Team</h2>
            <p>Experts driving our global pharmaceutical excellence</p>
        </div>
        <div className="team-grid">
            {teamMembers.map((member, idx) => (
                <div key={idx} className={`team-card ${member.isHoverable ? 'hoverable-card' : ''}`}>
                    {/* ✅ WhatsApp icon in top-right */}
                    {member.isHoverable && (
                        <a
                            href="https://wa.me/918490957541?text=Hello%2C%20I%20have%20a%20tech%20question%20regarding%20GLC%20IT%20services."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="wa-top-icon"
                        >
                            <FaWhatsapp />
                        </a>
                    )}

                    <div className="team-photo">
                        <img src={member.img} alt={member.name} />
                    </div>
                    <h3>{member.name}</h3>
                    <h6>{member.role}</h6>
                    <p>{member.about}</p>

                    {/* ✅ Hover box (if any) */}
                    {member.isHoverable && (
                        <div className="hover-info">
                            <p>Have a tech question or project idea? Feel free to connect via WhatsApp!</p>
                            <a
                                href="https://wa.me/918490957541"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="wa-link"
                            >
                                <FaWhatsapp className="wa-icon" />
                                Contact on WhatsApp
                            </a>
                        </div>
                    )}
                </div>
            ))}
        </div>
    </section>
);

export default TeamSection;
